<template>
  <div>
    <div v-if="finished">
      <mobile-step-header
              class="d-lg-none mobile-step-header"
              :steps="processSteps.steps"
              :currentStep="currentStep"
              @goToStep="goToStep"
      />
      <div id="inner">
        <b-row>
          <b-col sm="12">
            <h1>
              {{ stepTitle }}
            </h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="6">
            <keep-alive>
              <component
                      :is="currentComponent"
                      @registrationStepNext="nextStep"
                      @validated="setChildValidation"
                      @next="nextStep"
                      @previous="previousStep"
                      @reinit="init"
              >
              </component>
            </keep-alive>
          </b-col>
          <b-col sm="12" lg="5" offset-lg="1" class="form-info-block d-none d-lg-block">
            <Faq :faq="faq" :processSteps="processSteps" :currentStep="currentStep" @goToStep="goToStep"></Faq>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
        </b-row>
      </div>
    </div>
    <b-modal
            id="registration-errors"
            title="Let op!"
            size="lg"F
            ok-title="Sluiten"
            ok-variant="success"
            ok-only
		style="z-index: 99;"
    >
      <b-row v-for="err in currentErrors" :key="err.type">
        <b-col cols="12">
          <p v-html="err.text">

          </p>
        </b-col>
      </b-row>
    </b-modal>
    <BdPopup></BdPopup>
  </div>
</template>

<script>
import Faq from '@/components/_registration/Faq'
import Privacy from '@/components/_registration/Privacy'
import Naw from '@/components/_registration/Naw'
import Partner from '@/components/_registration/Partner'
import Family from '@/components/_registration/Family'
import { faqService, registrationService } from '@/_services'
import Situation from '@/components/_registration/Situation'
import Preferences from '@/components/_registration/Preferences'
import Payment from '@/components/_registration/Payment'
import Summary from '@/components/_registration/Summary'
import Wn from "./_registration/Wn";
import Unregister from "./_registration/Unregister";
import MobileStepHeader from '@/components/_registration/MobileStepHeader'
import Documents from '@/components/_registration/Documents'
import Password from '@/components/_registration/Password'
import BdPopup from "./_registration/BdPopup";

export default {
  components: {
    Faq,
    Privacy,
    Naw,
    Partner,
    Family,
    Situation,
    Preferences,
    Payment,
    Documents,
    Summary,
    Wn,
    Unregister,
    Password,
    MobileStepHeader,
    BdPopup
  },
  data: () => {
    return {
      currentComponent: '',
      currentErrors: [],
      faq: [],
      childState: {},
      /*highlightInvalid: false,*/
      finished: false,
      processSteps: {}
    }
  },
  name: 'Registration',
  computed: {
    currentStep: function () {
      return this.$store.state.registration.step
    },
    stepTitle: function () {
      return this.processSteps.steps[this.currentStep].title
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init() {
      registrationService.getState().then((data) => {
        let errs = {}
        this.processSteps = data
        this.$store.dispatch('registration/setNewUserState', data.newUser)
        data.errors.forEach((err) => {
          if(errs[err.page] === undefined) {
            errs[err.page] = []
          }
          errs[err.page].push(err)
        });
        this.$store.dispatch('registration/setErrors', errs)
        this.$store.dispatch('registration/setMaxStep',  data.steps.length - 1)
        this.$emit('childInitialized', {
          title: data.newUser ? 'Regel uw inschrijving' : 'Mijn profiel'
        })
        this.$store.dispatch('registration/setUser', this.$store.state.authentication.user.user.id)

        if(this.$route.query.step !== undefined) {
          this.processSteps.steps.forEach((element, index) => {
            if(element.page === this.$route.query.step) {
              this.$store.dispatch('registration/setStep', index)
            }
          })
        }

        this.loadStep()
        this.finished = true
      })
    },
    nextStep () {
      if (this.childState[this.currentComponent]) {
        if(this.$store.state.registration.newUser && this.$store.state.registration.step == this.$store.state.registration.maxStep) {
          window.location.href = '../passthrough.cfm'
        } else if(!this.$store.state.registration.newUser) {
          this.$store.dispatch('registration/setStep', 0)
          this.init()
        } else {
          this.$store.dispatch('registration/nextStep')
          this.loadStep()
        }
      }
    },
    previousStep () {
      if(this.$store.state.registration.step === 0 && !this.$store.state.registration.newUser) {
        window.location.href = '../passthrough.cfm'
      } else if(!this.$store.state.registration.newUser) {
        this.goToStep(0)
      } else {
        this.$store.dispatch('registration/previousStep')
        this.loadStep()
      }
    },
    goToStep (step) {
      this.$store.dispatch('registration/setStep', step)
      this.loadStep()
    },

loadStep () {
      this.currentComponent = this.processSteps.steps[this.currentStep].page
      this.loadFaq()

      if(this.$store.state.registration.errors[this.currentComponent] !== undefined) {
        this.currentErrors = this.$store.state.registration.errors[this.currentComponent]
        this.highlightInvalid = true
          this.$bvModal.show('registration-errors')
      }
      this.scrollToTop()
    },

loadFaq () {
      faqService.getSection(this.processSteps.steps[this.currentStep].page).then((data) => {
        this.faq = data
      })
    },
    setChildValidation (data) {
      this.childState[this.currentComponent] = data
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
